<template>
  <div
    class="screen-share-mask_wrap"
    :class="{
      'screen-share-mask_wrap_pause': remoteScreenShareInfo.status === 'pause',
    }"
  >
    <!-- 网页端 本地共享 -->
    <div
      class="local-screen-share-mask"
      v-if="screenShareStatus != 'end' && !isElectron"
    >
      <div class="tips">屏幕共享中</div>
      <div class="stop-btn" @click="handleStopShare">停止共享</div>
    </div>
    <!-- 拉流端展示 -->
    <div class="remote-share-wrap">
      <div
        v-show="showPullVideoStream"
        class="remote-share-box"
        ref="remoteShareBox"
      ></div>
      <div v-if="remoteScreenShareInfo.status === 'pause'" class="pause-box">
        老师已暂停屏幕共享
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { uploadLiveLog } from "@saas/components/src/utils/log";
export default {
  data() {
    return {
      isElectron: !!window.isElectron,
      currentScreenInfo: {},
    };
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "screenShareStatus",
      "remoteScreenShareInfo",
    ]),
    showPullVideoStream() {
      return this.remoteScreenShareInfo.status != "end";
    },
  },
  watch: {
    liveService(val) {
      if (val) {
        this.handleLiveServiceListener();
      }
    },
  },
  methods: {
    ...mapMutations("live", [
      "setScreenShareStatus",
      "setRemoteScreenShareInfo",
    ]),
    handleStopShare() {
      uploadLiveLog({
        message: "用户点击停止共享",
        extra: {
          component: "ScreenShare",
          action: "click_screen_share_stop",
          screenShareStatus: this.screenShareStatus,
          isElectron: this.isElectron,
        },
      });

      // 停止共享
      this.liveService.stopScreenCapture();
      this.setScreenShareStatus("end");
    },
    handleLiveServiceListener() {
      this.liveService.on(
        "userSubStreamAvailable",
        this.onUserSubStreamAvailable
      );
    },
    onUserSubStreamAvailable(res) {
      console.log("获取共享数据流", res);
      uploadLiveLog({
        message: "远端用户屏幕共享数据流变化",
        extra: {
          component: "ScreenShare",
          action: "onUserSubStreamAvailable",
          res: res,
        },
      });
      if (res.available === 1) {
        this.isRecivingShare = true;
        this.currentScreenInfo = res;
        this.setRemoteScreenShareInfo({
          status: "start",
        });
        this.$nextTick(() => {
          this.liveService.startRemoteSubView({
            userID: res.userID,
            view: this.$refs.remoteShareBox,
          });
        });
      } else {
        if (this.currentScreenInfo.userID === res.userID) {
          this.isRecivingShare = false;
          this.setRemoteScreenShareInfo({
            status: "end",
          });
        }
      }
      this.$emit("updateShareStatus", this.isRecivingShare);
    },
  },
};
</script>

<style lang="scss" scoped>
.screen-share-mask_wrap {
  z-index: 99;
  .local-screen-share-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(29, 33, 41, 0.4);
    backdrop-filter: blur(7px); /* 设置高斯模糊效果 */
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .tips {
      font-weight: 500;
      font-size: 20px;
      color: #000000;
      line-height: 24px;
    }
    .stop-btn {
      width: 84px;
      height: 36px;
      background: #cb2634;
      border-radius: 12px 12px 12px 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #f7f8fa;
      margin-top: 10px;
      cursor: pointer;
    }
  }
  .remote-share-wrap {
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    .remote-share-box {
      width: 100%;
      height: 100%;
    }
    .pause-box {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 970;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 32px;
      color: #ffffff;
      background: rgba(29, 33, 41, 0.4);
      backdrop-filter: blur(7px); /* 设置高斯模糊效果 */
    }
  }
}
.screen-share-mask_wrap_pause {
  z-index: unset;
}
</style>
